import TalkviaCalendar from './Index.vue';

export const routes = [
  {
    path: 'agenda',
    name: 'talkvia_calendar',
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
    component: TalkviaCalendar,
  },
];
